import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
  message = "Processing image..."
}) => {
  if (!isVisible) return null;

  return (
    <div className="absolute inset-0 bg-black/20 flex items-center justify-center z-50 rounded-lg">
      <div className="bg-white rounded-lg p-4 flex items-center gap-3">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span>{message}</span>
      </div>
    </div>
  );
};